/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Resync_SuccessInputs */



/**
* | output |
* | --- |
* | "Data resynchronized successfully" |
*
* @param {Profile_Resync_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resync_success = /** @type {((inputs?: Profile_Resync_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Resync_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Données resynchronisées avec succès")
	if (locale === "es") return /** @type {LocalizedString} */ ("Datos resincronizados exitosamente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dados ressincronizados com sucesso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dati risincronizzati con successo")
	return /** @type {LocalizedString} */ ("Data resynchronized successfully")
});